import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSignals from './components/TrustSignals';
import ServicesGrid from './components/ServicesGrid';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    description: 'Desguace líder en Barcelona. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Tasación gratuita en 24h, recogida gratis y pago inmediato.',
    url: siteUrl,
    telephone: '+34932932913',
    priceRange: '€€',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Barcelona',
      addressRegion: 'Cataluña',
      addressCountry: 'ES',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '41.3851',
      longitude: '2.1734',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '19:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '09:00',
        closes: '14:00',
      },
    ],
    sameAs: [],
    areaServed: {
      '@type': 'AdministrativeArea',
      name: 'Provincia de Barcelona',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Desguace Barcelona',
    url: siteUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Barcelona | Vende tu Coche al Mejor Precio | Tasación Inmediata"
        description="Desguace líder en Barcelona. Compramos tu coche siniestrado, averiado o sin ITV al mejor precio. Tasación gratuita en 24h, recogida gratis y pago inmediato. Más de 15 años de experiencia en Barcelona y provincia."
        keywords="desguace Barcelona, vender coche Barcelona, coche siniestrado Barcelona, coche averiado Barcelona, desguace cerca de mi, tasación coche Barcelona"
        canonical={`${siteUrl}/`}
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustSignals />
        <ServicesGrid />
        <ProcessSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
